import { sendGTMEvent } from '@next/third-parties/google';
import { IData } from './types';

export const push = (data: IData) => {
  try {
    sendGTMEvent(data);
  } catch (err) {
    console.error('window.dataLayer is not defined');
  }

  return data;
};
